export default "__VITE_ASSET__C8TXJnst__"